import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxResponse } from '@models/gift';
import dayjs from 'dayjs';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxResponse
}

function PurchaseInfo({ giftBox }:Props) {
    const {
        receiverName, giftCoupon, payment,
    } = giftBox;
    const { t } = useTranslation('gift');

    const getCouponStatusKey = (status: string) => {
        const statusMap: Record<string, string> = {
            ISSUED: 'issued',
            USED: 'used',
            CANCELED: 'canceled',
            EXPIRED: 'expired',
            CANCEL_FAILED: 'cancelFailed',
            SENT: 'sent',
            SEND_FAILED: 'sendFailed',
            OFF_USED: 'offUsed',
            DEACTIVATED: 'deactivated',
        };
        return `couponStatus.${statusMap[status] || status.toLowerCase()}`;
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <Text color={colors.gray6}>{t('giftSent.receiver')}</Text>
                <Text fontWeight='bold' color={colors.gray7}>{receiverName}</Text>
                {giftCoupon && (
                    <Fragment>
                        <Text color={colors.gray6}>{t('giftSent.validPeriod')}</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {dayjs(giftCoupon.startedAt).format('YYYY.MM.DD')}
                            &nbsp;~&nbsp;
                            {dayjs(giftCoupon.expiredAt).format('YYYY.MM.DD')}
                        </Text>
                        <Text color={colors.gray6}>{t('giftSent.couponStatus')}</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {t(getCouponStatusKey(giftCoupon.status))}
                        </Text>
                    </Fragment>
                )}
                <Text color={colors.gray6}>{t('giftSent.paymentMethod')}</Text>
                <Text fontWeight='bold' color={colors.gray7}>
                    {payment.paymentMethod === 'CREDIT_CARD' ? t('giftSent.creditCard') : t('giftSent.prepaidCard')}
                </Text>
                <Text color={colors.gray6}>{t('giftSent.paymentAmount')}</Text>
                <Text fontWeight='bold' color={colors.red}>
                    {payment.amount.toLocaleString()}{t('item.priceUnit')}
                </Text>
            </div>
        </div>
    );
}

export default PurchaseInfo;
